"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadNextPage = exports.onChatOverviewClick = exports.onMessageSend = exports.onSendMessageToUserChat = exports.onSendMessageToFlightChat = exports.sendMessageHandler = exports.getMessagesWithoutChatIdHandler = exports.getAllChatsHandler = void 0;
const messages_1 = require("../http/messages");
const message_1 = require("../store/redux/message");
const store_1 = require("../store/redux/store");
const messageHelper_1 = require("../services/messageHelper");
const utils_1 = require("../services/utils");
const lodash_1 = require("lodash");
const getAllChatsHandler = () => {
    (0, messages_1.getAllChats)().then(response => {
        response.forEach((chat) => {
            if (chat.last_message?.content)
                chat.last_message.content = (0, messageHelper_1.decodeMessageContent)(chat.last_message.content);
            if (chat.flight)
                chat.flight = (0, utils_1.prepareFlightDetailsData)(chat.flight);
        });
        store_1.store.dispatch((0, message_1.setAllChats)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.getAllChatsHandler = getAllChatsHandler;
const getMessagesWithChatIdHandler = async (chatId, page, navigateToChat) => {
    (0, messages_1.getMessagesWithChatId)(chatId, page).then(response => {
        const sortedResponse = JSON.parse(JSON.stringify(response)).reverse();
        sortedResponse.forEach((message) => {
            message.content = (0, messageHelper_1.decodeMessageContent)(message.content);
        });
        store_1.store.dispatch((0, message_1.addMessageAction)(sortedResponse));
        navigateToChat();
    }).catch(error => {
        console.log(error);
    });
};
const getMessagesWithoutChatIdHandler = async (flightId, receiverId, initiatorId, page) => {
    (0, messages_1.getMessagesWithoutChatId)(flightId, receiverId, initiatorId, page).then(response => {
        const sortedResponse = JSON.parse(JSON.stringify(response)).reverse();
        sortedResponse.forEach((message) => {
            message.content = (0, messageHelper_1.decodeMessageContent)(message.content);
        });
        store_1.store.dispatch((0, message_1.addMessageAction)(sortedResponse));
    }).catch(error => {
        console.log(error);
    });
};
exports.getMessagesWithoutChatIdHandler = getMessagesWithoutChatIdHandler;
const sendMessageHandler = async (flightId, receiverId, initiatorId, message) => {
    store_1.store.dispatch((0, message_1.sendMessageAction)(message));
    const encodeMessage = (0, messageHelper_1.encodeMessageContent)(message.content);
    (0, messages_1.sendMessage)(flightId, receiverId, initiatorId, encodeMessage).then(() => {
    }).catch(error => {
        console.log(error);
    });
};
exports.sendMessageHandler = sendMessageHandler;
const onSendMessageToFlightChat = async ({ flightData, navigateToChat }) => {
    store_1.store.dispatch((0, message_1.resetCurrentChat)());
    store_1.store.dispatch((0, message_1.setAsGroupChat)());
    store_1.store.dispatch((0, message_1.setChatFlight)(flightData));
    if (flightData.id)
        await (0, exports.getMessagesWithoutChatIdHandler)(flightData.id, null, null, null);
    navigateToChat();
};
exports.onSendMessageToFlightChat = onSendMessageToFlightChat;
const onSendMessageToUserChat = async ({ initiator, receiver, navigateToChat }) => {
    store_1.store.dispatch((0, message_1.resetCurrentChat)());
    store_1.store.dispatch((0, message_1.setChatReceiver)(receiver));
    store_1.store.dispatch((0, message_1.setChatInitiator)(initiator));
    store_1.store.dispatch((0, message_1.setChatUsers)([receiver, initiator]));
    await (0, exports.getMessagesWithoutChatIdHandler)(null, receiver.id, initiator.id, null);
    navigateToChat();
};
exports.onSendMessageToUserChat = onSendMessageToUserChat;
const onMessageSend = ({ input, user, socket, setInput }) => {
    if (input !== "") {
        const message = {
            sender: user,
            timestamp: (new Date().toISOString()),
            read_timestamp: (new Date().toISOString()),
            content: input,
            id: (0, lodash_1.uniqueId)("local_"),
        };
        const encodeMessage = (0, messageHelper_1.encodeMessageContent)(message.content);
        if (socket?.readyState) {
            console.log("Socket ready send message");
            socket?.send(encodeMessage);
            store_1.store.dispatch((0, message_1.sendMessageAction)(message));
        }
        setInput('');
    }
};
exports.onMessageSend = onMessageSend;
const onChatOverviewClick = ({ chat, navigateToChat }) => {
    store_1.store.dispatch((0, message_1.resetCurrentChat)());
    store_1.store.dispatch((0, message_1.setCurrentChatId)(chat?.id));
    if (chat.flight) {
        store_1.store.dispatch((0, message_1.setAsGroupChat)());
        store_1.store.dispatch((0, message_1.setChatFlight)(chat.flight));
    }
    else {
        store_1.store.dispatch((0, message_1.setChatReceiver)(chat?.receiver));
        store_1.store.dispatch((0, message_1.setChatInitiator)(chat?.initiator));
    }
    store_1.store.dispatch((0, message_1.setChatUsers)(chat.group_chat_users));
    store_1.store.dispatch((0, message_1.setMessagesCount)(chat.messages_count));
    chat.id && getMessagesWithChatIdHandler(chat.id, null, navigateToChat).then(() => (0, exports.getAllChatsHandler)());
};
exports.onChatOverviewClick = onChatOverviewClick;
const loadNextPage = async ({ numberOfPages, flightData, receiverData, initiatorData, nextPage }) => {
    if (numberOfPages && numberOfPages > 1) {
        if (flightData && nextPage) {
            store_1.store.dispatch((0, message_1.setNextPage)(nextPage + 1));
            await (0, exports.getMessagesWithoutChatIdHandler)(flightData.id, null, null, nextPage);
        }
        if (receiverData && initiatorData && nextPage) {
            store_1.store.dispatch((0, message_1.setNextPage)(nextPage + 1));
            await (0, exports.getMessagesWithoutChatIdHandler)(null, receiverData.id, initiatorData.id, nextPage);
        }
    }
    return true;
};
exports.loadNextPage = loadNextPage;
